/* DREAMY: skrypt sklepu na Shopify (24.09.2026).
   Przeniesiony ze strona.html bez przelaczania widokow (kazda strona ma teraz swoj adres) i z prawdziwym koszykiem
   (Shopify AJAX API: /cart/add.js, /cart.js, /cart/change.js). Pasek u gory, okienka, walidacja newslettera
   i przelacznik jezyka dzialaja jak na podgladzie. */
(()=>{
  const doc=document.documentElement;
  let ang=false;                 // czy strona jest po angielsku
  const $=(s,r=document)=>r.querySelector(s), $$=(s,r=document)=>[...r.querySelectorAll(s)];
  const widok=()=>doc.dataset.widok||'glowna';
  const bezRuchu=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
  const zwyklyKlik=e=>!(e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey);
  const KORZEN=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  const WALUTA=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'PLN';
  const zl=grosze=>new Intl.NumberFormat(ang?'en-GB':'pl-PL',{style:'currency',currency:WALUTA}).format(grosze/100);

  // wysokosc paska -> hero na pelny ekran bez przewijania
  const nav=$('.nav'), gora=$('.gora');
  const mierz=()=>{
    doc.style.setProperty('--navH',nav.offsetHeight+'px');
    doc.style.setProperty('--barH',gora.offsetHeight+'px');
  };
  mierz(); new ResizeObserver(mierz).observe(nav); new ResizeObserver(mierz).observe(gora);

  // tekst i guzik w hero: srodek miedzy dolem maski a dolem zdjecia; na telefonie gorna czesc napisu
  // w polowie miedzy gora zdjecia a gora maski. 220 i 541 z 768 px to gora i dol maski w pliku zdjecia.
  const heroEl=$('.hero'), foto=$('.hero .shot');
  if(heroEl && foto){
    const GORA_MASKI=220, DOL_MASKI=541, SZER_ZDJ=1376, WYS_ZDJ=768;
    const ustawCopy=()=>{
      const iw=foto.naturalWidth||SZER_ZDJ, ih=foto.naturalHeight||WYS_ZDJ;
      const H=heroEl.getBoundingClientRect(), S=foto.getBoundingClientRect();
      if(!H.height) return;
      const k=Math.max(S.width/iw, S.height/ih);
      const py=(parseFloat((getComputedStyle(foto).objectPosition||'').split(' ')[1])||50)/100;
      const g=S.top+(S.height-ih*k)*py;
      const dol=(g+DOL_MASKI/WYS_ZDJ*ih*k-H.top)/H.height*100;
      doc.style.setProperty('--copyTop',((dol+100)/2).toFixed(2)+'%');
      const srodekRzedu=(dol+100)/200*H.height;
      const nad=(Math.max(0,g-H.top)+(g+GORA_MASKI/WYS_ZDJ*ih*k-H.top))/2;
      doc.style.setProperty('--odstepNad',(srodekRzedu-nad).toFixed(1)+'px');
    };
    (foto.decode?foto.decode().catch(()=>{}):Promise.resolve()).then(ustawCopy);
    ustawCopy(); new ResizeObserver(ustawCopy).observe(heroEl);
  }

  // ---- okienka (koszyk, menu, newsletter) i pasek zakupu ----
  const burger=$('#burger'), menuEl=$('#menu-szuflada');
  const s=$('.sticky');
  if(s) new ResizeObserver(()=>doc.style.setProperty('--stickyH',s.offsetHeight+'px')).observe(s);
  const scrim=$('#scrim'), drawer=$('#drawer'), okno=$('#okno-newsletter');
  let koszykOtwarty=false, poStrefie=false, oknoOtwarte=false, menuOtwarte=false;
  const blokuj=()=>{document.body.style.overflow=(koszykOtwarty||oknoOtwarte||menuOtwarte)?'hidden':'';};
  // pasek zakupu: na glownej po zjechaniu ze zdjecia, na stronie maski po minieciu przycisku zakupu
  const odswiezPasek=()=>{
    if(!s) return;
    const on=poStrefie && (widok()==='glowna'||widok()==='produkt');
    s.classList.toggle('on',on); s.inert=!on||koszykOtwarty||oknoOtwarte||menuOtwarte;
  };
  // pasek zakupu: na glownej juz po 35% zdjecia hero (prosba 25.09: "chce zeby pojawial sie wczesniej"),
  // na stronie maski po minieciu przycisku zakupu
  const strefa=widok()==='glowna'?heroEl:widok()==='produkt'?$('#kup'):null;
  if(strefa && s){
    const prog=()=>{ const r=strefa.getBoundingClientRect(); const gora=r.top+scrollY;
      return widok()==='glowna' ? gora+r.height*.35 : gora+r.height; };
    let czeka=false;
    const sprawdz=()=>{ czeka=false; const teraz=scrollY>prog(); if(teraz!==poStrefie){ poStrefie=teraz; odswiezPasek(); } };
    addEventListener('scroll',()=>{ if(!czeka){ czeka=true; requestAnimationFrame(sprawdz); } },{passive:true});
    addEventListener('resize',sprawdz);
    sprawdz();
  }

  // zakladka menu strony, na ktorej jestes: aria-current, w CSS bledsza
  const linkiMenu=$$('.menu-linki a');
  const tutaj=location.pathname.replace(/\/+$/,'')||'/';
  linkiMenu.forEach(a=>{
    const p=new URL(a.href,location.href).pathname.replace(/\/+$/,'')||'/';
    const tu=a.hasAttribute('data-faq') ? false
      : p.startsWith('/products/') ? tutaj.startsWith('/products/') : p===tutaj;
    if(tu) a.setAttribute('aria-current','page');
  });
  // "Przejdz do tresci": fokus na tresc, bez dopisywania #tresc do adresu
  const przeskocz=$('.przeskocz');
  if(przeskocz) przeskocz.addEventListener('click',e=>{ e.preventDefault(); $('#tresc').focus({preventScroll:true}); });
  // "Wysylka tego samego dnia*": w dol do przypisu w stopce, bez #... w adresie
  const przypis=$('#przypis-wysylka'), wysylka=$('.wysylka-krotka');
  if(przypis && wysylka) wysylka.addEventListener('click',e=>{
    if(!zwyklyKlik(e)) return;
    e.preventDefault();
    przypis.closest('footer').scrollIntoView({block:'end',behavior:bezRuchu()?'auto':'smooth'});
    przypis.focus({preventScroll:true});
  });

  // Reszta strony dostaje "inert" - Tab i czytnik ekranu jej nie widza. Fokus wchodzi do okienka,
  // a po zamknieciu wraca na przycisk, ktory je otworzyl.
  let skadFokus=null;
  const ustawTlo=()=>{
    const modal=koszykOtwarty||oknoOtwarte||menuOtwarte;
    [...document.body.children].filter(x=>!x.matches('script,.okno,.drawer,.menu-szuflada,.scrim,.sticky'))
      .forEach(x=>{ x.inert=modal; });
    drawer.inert=!koszykOtwarty; okno.inert=!oknoOtwarte; menuEl.inert=!menuOtwarte;
    scrim.classList.toggle('on',koszykOtwarty||menuOtwarte);
    odswiezPasek(); blokuj();
    if(!modal && skadFokus){
      if(skadFokus.isConnected) skadFokus.focus({preventScroll:true});
      skadFokus=null;
    }
  };
  const otworz=(v,skad)=>{
    if(v===koszykOtwarty) return;
    if(v && !skadFokus) skadFokus=skad||document.activeElement;
    koszykOtwarty=v; drawer.classList.toggle('on',v);
    ustawTlo();
    if(v) drawer.focus({preventScroll:true});
  };
  function otworzMenu(v,skad){
    if(v===menuOtwarte) return;
    if(v && !skadFokus) skadFokus=skad||document.activeElement;
    menuOtwarte=v; menuEl.classList.toggle('on',v);
    burger.setAttribute('aria-expanded',String(v));
    ustawTlo();
    if(v) menuEl.focus({preventScroll:true});
  }
  burger.addEventListener('click',e=>otworzMenu(!menuOtwarte,e.currentTarget));
  $('#zamknij-menu').addEventListener('click',()=>otworzMenu(false));
  linkiMenu.forEach(a=>a.addEventListener('click',()=>{ skadFokus=null; otworzMenu(false); }));
  // "Czesto zadawane pytania": na glownej plynne przewiniecie, z innych stron zwykle przejscie na /#faq
  $$('[data-faq]').forEach(a=>a.addEventListener('click',e=>{
    if(!zwyklyKlik(e) || widok()!=='glowna' || !$('#faq')) return;
    e.preventDefault();
    $('#faq').scrollIntoView({block:'start',behavior:bezRuchu()?'auto':'smooth'});
    const t=$('#faq-tytul'); if(t) t.focus({preventScroll:true});
  }));

  // ---- galeria maski: miniatury przewijaja duze zdjecia, przewijanie zaznacza miniature ----
  $$('.galeria-zestaw').forEach(g=>{
    const tor=$('.galeria-slajdy',g), mini=$$('.miniatura',g);
    if(!tor || !mini.length) return;
    const zaznacz=i=>mini.forEach((b,k)=>{
      b.classList.toggle('on',k===i);
      if(k===i) b.setAttribute('aria-current','true'); else b.removeAttribute('aria-current');
    });
    mini.forEach((b,i)=>b.addEventListener('click',()=>{
      tor.scrollTo({left:tor.clientWidth*i,behavior:bezRuchu()?'auto':'smooth'}); zaznacz(i);
    }));
    let t=null;
    tor.addEventListener('scroll',()=>{
      clearTimeout(t);
      t=setTimeout(()=>zaznacz(Math.round(tor.scrollLeft/Math.max(1,tor.clientWidth))),80);
    },{passive:true});
  });

  // ---- kolor maski i zestawy ----
  const dane=(()=>{ try{ return JSON.parse($('#dane-produktu').textContent); }catch(_){ return null; } })();
  const kolor=()=>doc.dataset.kolor==='black'?'black':'pink';
  const radiaKoloru=$$('input[name="kolor"]');
  const karty=$$('.zestaw'), radiaZestawu=$$('input[name="zestaw"]'), cenaZestawu=$('#cena-zestawu');
  const ustawZestaw=()=>{
    const w=radiaZestawu.find(r=>r.checked);
    karty.forEach(k=>k.classList.toggle('wybrany', !!w && k.contains(w)));
    if(cenaZestawu && w && w.dataset.cena) cenaZestawu.textContent=zl(+w.dataset.cena);
  };
  radiaZestawu.forEach(r=>r.addEventListener('change',ustawZestaw));
  const ustawKolor=(k,{adres=true}={})=>{
    if(k==='black') doc.dataset.kolor='black'; else delete doc.dataset.kolor;
    radiaKoloru.forEach(r=>{ r.checked=r.value===k; });
    if(dane) doc.dataset.dostepny=(dane[k]&&dane[k].dostepny)?'1':'0';
    if(adres && dane && dane[k] && dane[k].url && widok()==='produkt'){
      try{ history.replaceState(history.state,'',dane[k].url); }catch(_){}
    }
    ustawZestaw();
  };
  radiaKoloru.forEach(r=>r.addEventListener('change',()=>{ if(r.checked) ustawKolor(r.value); }));
  if(dane) ustawKolor(kolor(),{adres:false}); else ustawZestaw();

  // ---- koszyk (Shopify) ----
  const lista=$('#koszyk-pozycje'), pusty=$('#koszyk-pusty'), podsum=$('#koszyk-podsumowanie');
  const statusK=$('#koszyk-status'), sumaK=$('#koszyk-suma'), rabatyK=$('#koszyk-rabaty'), komK=$('#koszyk-komunikat');
  const liczniki=$$('[data-licznik]'), komKup=$('#kup-komunikat');
  let koszyk=null;
  const odmiana=n=>n===1?'produkt':(n%10>=2&&n%10<=4&&(n%100<12||n%100>14))?'produkty':'produktów';
  const el=(tag,klasa,tekst)=>{ const e=document.createElement(tag); if(klasa) e.className=klasa; if(tekst!=null) e.textContent=tekst; return e; };
  const przycisk=(tekst,klucz,ilosc,etykieta)=>{
    const b=el('button',null,tekst); b.type='button'; b.dataset.klucz=klucz; b.dataset.ilosc=ilosc;
    if(etykieta) b.setAttribute('aria-label',etykieta); return b;
  };
  const rysuj=c=>{
    koszyk=c;
    liczniki.forEach(l=>{ l.textContent=c.item_count; l.hidden=!c.item_count; });
    const puste=!c.item_count;
    pusty.hidden=!puste; lista.hidden=puste; podsum.hidden=puste;
    statusK.textContent=puste ? (ang?'Your cart is empty':'Koszyk jest pusty')
      : ang ? `${c.item_count} ${c.item_count===1?'item':'items'}` : `${c.item_count} ${odmiana(c.item_count)}`;
    lista.replaceChildren(...c.items.map(it=>{
      const li=el('li','pozycja');
      const img=el('img');
      if(it.image){ try{ const u=new URL(it.image,location.href); u.searchParams.set('width','160'); img.src=u.href; }catch(_){ img.src=it.image; } }
      img.alt=''; img.width=72; img.height=72; img.loading='lazy';
      const opis=el('div','opis');
      opis.append(el('b',null,it.product_title));
      if(it.variant_title && it.variant_title!=='Default Title') opis.append(el('span','wariant',it.variant_title));
      const ilosc=el('div','ilosc');
      const minus=przycisk('−',it.key,it.quantity-1, ang?`One less: ${it.product_title}`:`Jedna mniej: ${it.product_title}`);
      const plus=przycisk('+',it.key,it.quantity+1, ang?`One more: ${it.product_title}`:`Jedna więcej: ${it.product_title}`);
      const n=el('span',null,String(it.quantity)); n.setAttribute('aria-label',ang?`Quantity: ${it.quantity}`:`Ilość: ${it.quantity}`);
      ilosc.append(minus,n,plus);
      const usun=przycisk(ang?'Remove':'Usuń',it.key,0); usun.className='usun';
      opis.append(ilosc,usun);
      const ceny=el('div','ceny');
      ceny.append(el('span',null,zl(it.final_line_price)));
      if(it.original_line_price>it.final_line_price) ceny.append(el('s',null,zl(it.original_line_price)));
      li.append(img,opis,ceny);
      return li;
    }));
    const rabat=c.total_discount||0;
    rabatyK.hidden=!rabat;
    if(rabat){
      const nazwy=[...new Set([...(c.cart_level_discount_applications||[]).map(d=>d.title),
        ...c.items.flatMap(i=>(i.line_level_discount_allocations||[]).map(a=>a.discount_application&&a.discount_application.title))])].filter(Boolean);
      rabatyK.textContent=`${nazwy.join(', ')||(ang?'Discount':'Rabat')}: −${zl(rabat)}`;
    }
    sumaK.textContent=zl(c.total_price);
  };
  const odswiezKoszyk=async()=>{
    const r=await fetch(`${KORZEN}cart.js`,{headers:{Accept:'application/json'}});
    if(!r.ok) throw new Error(r.status);
    const c=await r.json(); rysuj(c); return c;
  };
  lista.addEventListener('click',async e=>{
    const b=e.target.closest('button[data-klucz]'); if(!b) return;
    b.disabled=true; komK.textContent='';
    try{
      const r=await fetch(`${KORZEN}cart/change.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({id:b.dataset.klucz,quantity:+b.dataset.ilosc})});
      if(!r.ok) throw new Error(r.status);
      rysuj(await r.json());
      if(!drawer.contains(document.activeElement)) drawer.focus({preventScroll:true});   // usuniety przycisk zniknal
    }catch(_){
      komK.textContent=ang?'Could not update the cart. Try again.':'Nie udało się zmienić koszyka. Spróbuj jeszcze raz.';
      b.disabled=false;
    }
  });
  $$('[data-open-cart]').forEach(b=>b.addEventListener('click',()=>{ otworz(true,b); odswiezKoszyk().catch(()=>{}); }));
  $('#close-cart').addEventListener('click',()=>otworz(false));
  scrim.addEventListener('click',()=>{ otworz(false); otworzMenu(false); });
  odswiezKoszyk().catch(()=>{});      // licznik w pasku i zawartosc szuflady po wejsciu na strone

  // dodanie do koszyka: jedna maska albo Zestaw dla par (dwie maski, kolor drugiej do wyboru)
  const pozycjeZWyboru=()=>{
    const k=kolor(), w=radiaZestawu.find(r=>r.checked);
    if(!w || w.value!=='2') return [{id:dane[k].id,quantity:1}];
    const drugi=($('input[name="kolor-z2-2"]:checked')||{}).value||'pink';
    return drugi===k ? [{id:dane[k].id,quantity:2}] : [{id:dane[k].id,quantity:1},{id:dane[drugi].id,quantity:1}];
  };
  let dodaje=false;
  const dodaj=async(items,guzik)=>{
    if(dodaje) return;
    dodaje=true; if(guzik) guzik.disabled=true;
    if(komKup) komKup.textContent='';
    try{
      const r=await fetch(`${KORZEN}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({items})});
      if(!r.ok) throw Object.assign(new Error('koszyk'),{status:r.status});
      await odswiezKoszyk();
      otworz(true,guzik);
    }catch(err){
      const t=err.status===422 ? (ang?'Sorry, this mask is out of stock.':'Przykro nam, tej maski właśnie zabrakło.')
        : (ang?'Could not add to cart. Try again in a moment.':'Nie udało się dodać do koszyka. Spróbuj za chwilę.');
      if(komKup) komKup.textContent=t;
      else { komK.textContent=t; otworz(true,guzik); }
    }finally{ dodaje=false; if(guzik) guzik.disabled=false; }
  };
  const dodajBtn=$('#dodaj');
  if(dodajBtn && dane) dodajBtn.addEventListener('click',()=>dodaj(pozycjeZWyboru(),dodajBtn));
  const dodajSticky=$('#dodaj-sticky');
  if(dodajSticky) dodajSticky.addEventListener('click',()=>{
    if(dodajBtn && dane){
      if(doc.dataset.dostepny==='0'){ const p=$('#powiadom-o-dostawie'); if(p) p.click(); return; }
      dodaj(pozycjeZWyboru(),dodajSticky);
    }else dodaj([{id:+dodajSticky.dataset.wariant,quantity:1}],dodajSticky);
  });

  // ---- pasek informacyjny: zmiana co 7 s, mozna go chwycic i przeciagnac ----
  {
    const pasek=$('.pasek'), el2=[...pasek.children], N=el2.length;
    const POSTOJ=7000, WEJ=900, WYJ=600, ZAKLADKA=400;          // ms
    const W_GORE='cubic-bezier(.39,.575,.565,1)', W_DOL='cubic-bezier(.47,0,.745,.715)';
    const dryf=()=>bezRuchu()?0:parseFloat(getComputedStyle(pasek).fontSize)*1.8;
    const drogaZmiany=()=>Math.min(160, pasek.clientWidth*.25);
    let i=0, zegar=null, najechany=false;
    const ustaw=(e,x,o,przejscie='')=>{
      e.style.transition=przejscie||'none';
      e.style.transform=`translateX(${x}px)`;
      e.style.opacity=o;
      e.style.pointerEvents=o>.5?'auto':'none';
    };
    const znika=ms=>`opacity ${ms}ms ${W_DOL}, transform ${ms}ms ${W_DOL}`;
    const wchodzi=(ms,opozn=0)=>`opacity ${ms}ms ${W_GORE} ${opozn}ms, transform ${ms}ms ${W_GORE} ${opozn}ms`;
    const zmien=(nowy,kier)=>{
      const d=dryf(), n=el2[nowy];
      ustaw(el2[i], -kier*d, 0, znika(WYJ));
      ustaw(n, kier*d, 0);
      n.getBoundingClientRect();
      n.style.transition=wchodzi(WEJ,ZAKLADKA); n.style.transform='translateX(0)'; n.style.opacity=1;
      n.style.pointerEvents='auto';
      i=nowy;
    };
    const planuj=(ms=POSTOJ)=>{
      clearTimeout(zegar);
      if(najechany) return;
      zegar=setTimeout(()=>{ zmien((i+1)%N,1); planuj(POSTOJ+WEJ+ZAKLADKA); }, ms);
    };
    let start=null, t0=0, dx=0, ciagnie=false, blokujKlik=false, palec=null;
    pasek.addEventListener('pointerenter',()=>{najechany=true; clearTimeout(zegar);});
    pasek.addEventListener('pointerleave',()=>{
      najechany=false;
      if(start!==null && !ciagnie){ start=null; palec=null; }
      if(start===null) planuj();
    });
    pasek.addEventListener('focusin',e=>{
      najechany=true; clearTimeout(zegar);
      const k=el2.findIndex(x=>x.contains(e.target));
      if(k>=0 && k!==i){ ustaw(el2[i], 0, 0, znika(180)); ustaw(el2[k], 0, 1, wchodzi(180)); i=k; }
    });
    pasek.addEventListener('focusout',()=>{najechany=false; planuj();});
    pasek.addEventListener('pointerdown',e=>{
      if(e.button!==0 || start!==null) return;
      palec=e.pointerId;
      start=e.clientX; t0=performance.now(); dx=0; ciagnie=false; blokujKlik=false;
      clearTimeout(zegar);
    });
    pasek.addEventListener('pointermove',e=>{
      if(start===null || e.pointerId!==palec) return;
      dx=e.clientX-start;
      if(!ciagnie){
        if(Math.abs(dx)<6) return;
        ciagnie=true; pasek.classList.add('ciagnie');
        try{ pasek.setPointerCapture(e.pointerId); }catch(_){}
      }
      const kier=dx<0?1:-1, sas=el2[(i+kier+N)%N], p=Math.min(1,Math.abs(dx)/drogaZmiany());
      el2.forEach(x=>{ if(x!==el2[i]&&x!==sas) ustaw(x,0,0); });
      ustaw(el2[i], bezRuchu()?0:dx*.35, 1-p);
      ustaw(sas, kier*dryf()*(1-p), p);
    });
    const pusc=e=>{
      if(start===null || (e && e.pointerId!==undefined && e.pointerId!==palec)) return;
      start=null; palec=null;
      if(!ciagnie){ planuj(); return; }
      pasek.classList.remove('ciagnie'); ciagnie=false; blokujKlik=true;
      const kier=dx<0?1:-1, sas=(i+kier+N)%N, d=dryf();
      const szybko=Math.abs(dx)>=30 && Math.abs(dx)/Math.max(1,performance.now()-t0) > .5;
      if(Math.abs(dx)>drogaZmiany()*.4 || szybko){
        ustaw(el2[i], -kier*d*1.4, 0, znika(360));
        ustaw(el2[sas], 0, 1, wchodzi(460));
        i=sas;
      }else{
        ustaw(el2[i], 0, 1, wchodzi(360));
        ustaw(el2[sas], kier*d, 0, znika(300));
      }
      planuj(POSTOJ+460);
    };
    pasek.addEventListener('pointerup',pusc);
    pasek.addEventListener('pointercancel',pusc);
    pasek.addEventListener('lostpointercapture',e=>{ if(e.target===pasek) pusc(e); });
    addEventListener('blur',pusc);
    pasek.addEventListener('click',e=>{
      if(blokujKlik){ e.preventDefault(); e.stopPropagation(); blokujKlik=false; }
    },true);
    planuj();
  }

  // ---- okienko zapisu do newslettera (formularz klienta Shopify) ----
  // Formularz wysyla sie zwyczajnie: Shopify zapisuje adres z tagiem "newsletter" i wraca na te sama strone.
  const formN=$('#form-newsletter'), mailN=$('#mail-newsletter'), zgodaN=$('#zgoda-newsletter');
  const komN=$('#komunikat-newsletter'), udaneN=$('#udane-newsletter'), tagiN=$('#tagi-newsletter');
  const guzN=formN.querySelector('button[type=submit]');
  const pokazOkno=(v,skad,samo)=>{
    if(v===oknoOtwarte) return;
    if(v && !skadFokus) skadFokus=skad||document.activeElement;
    oknoOtwarte=v; okno.classList.toggle('on',v);
    ustawTlo();
    if(v && samo){ okno.focus({preventScroll:true});
      [240,600].forEach(ms=>setTimeout(()=>{ if(oknoOtwarte && !okno.contains(document.activeElement)) okno.focus({preventScroll:true}); },ms)); }
    else if(v) setTimeout(()=>{ if(oknoOtwarte) (okno.classList.contains('gotowe')?udaneN:mailN).focus({preventScroll:true}); },240);
  };
  let zrodloZapisu='pasek';
  // kopiowanie kodu rabatowego z ekranu po zapisie
  const kopiuj=$('#kopiuj-kod'), kopiujStatus=$('#kopiuj-status');
  if(kopiuj) kopiuj.addEventListener('click',()=>{
    const kod=$('#kod-rabat').textContent.trim(), ang=document.documentElement.lang==='en';
    const ok=()=>{ kopiujStatus.textContent=ang?'Code copied.':'Skopiowano kod.'; };
    if(navigator.clipboard) navigator.clipboard.writeText(kod).then(ok,()=>{ kopiujStatus.textContent=ang?'Select the code and copy it.':'Zaznacz kod i skopiuj go.'; });
    else kopiujStatus.textContent=ang?'Select the code and copy it.':'Zaznacz kod i skopiuj go.';
  });
  $('#otworz-newsletter').addEventListener('click',e=>{ zrodloZapisu='pasek'; pokazOkno(true,e.currentTarget); });
  const powiadom=$('#powiadom-o-dostawie');
  if(powiadom) powiadom.addEventListener('click',e=>{ zrodloZapisu='powrot-black'; pokazOkno(true,e.currentTarget); });
  $('#zamknij-newsletter').addEventListener('click',()=>pokazOkno(false));
  okno.addEventListener('click',e=>{if(e.target===okno)pokazOkno(false);});

  const pamiec=(m,k,v)=>{ try{ const st=window[m]; if(v===undefined) return st.getItem(k); st.setItem(k,v); }catch(_){} return null; };
  const jestZapisany=()=>pamiec('localStorage','dreamy-newsletter')==='zapisany';
  const naglowekWidoku=()=>{
    const h=$$('main h1').find(x=>x.offsetParent)||null;
    if(h && !h.hasAttribute('tabindex')) h.tabIndex=-1;
    return h;
  };

  // adres e-mail: pelna postac (nazwa@domena.pl) i nie z poczty jednorazowej (10minutemail itp.)
  const JEDNORAZOWE=new Set(('grr.la sharklasers.com spam4.me pokemail.net binkmail.com bobmail.info chammy.info '+
    'devnullmail.com letthemeatspam.com mailinater.com reallymymail.com reconmail.com safetymail.info sendspamhere.com '+
    'sogetthis.com spambooger.com spamherelots.com spamhereplease.com spamthisplease.com streetwisemail.com suremail.info '+
    'thisisnotmyrealemail.com tradermail.info veryrealemail.com zippymail.info cool.fr.nf courriel.fr.nf moncourrier.fr.nf '+
    'monemail.fr.nf monmail.fr.nf nomail.xl.cx nospam.ze.tc mega.zik.dj speed.1s.fr tempail.com tempinbox.com tempr.email '+
    'tempomail.fr tempemail.net temporary-mail.net tempm.com kurzepost.de objectmail.com proxymail.eu rcpt.at trashymail.com '+
    'mailmetrash.com maildrop.cc dispostable.com getnada.com nada.email abyssmail.com boximail.com clrmail.com dropjar.com '+
    'getairmail.com givmail.com inboxbear.com robot-mail.com tafmail.com vomoto.com zetmail.com mohmal.com emailondeck.com '+
    'mintemail.com mytemp.email discard.email spambog.com spambog.de spambog.ru 0815.ru mailnesia.com mailcatch.com '+
    'inboxkitten.com emailfake.com email-fake.com generator.email tmpmail.org tmpmail.net moakt.com moakt.cc moakt.co moakt.ws '+
    'minuteinbox.com spamgourmet.com spamgourmet.net spamgourmet.org mailpoof.com anonbox.net mailexpire.com filzmail.com '+
    'harakirimail.com dropmail.me 10mail.org emltmp.com emlpro.com emlhub.com yomail.info mail.tm mail.gw mail7.io mailsac.com '+
    'mailforspam.com spamfree24.org spamfree24.de spamdecoy.net spamavert.com armyspy.com cuvox.de dayrep.com einrot.com '+
    'fleckens.hu gustr.com jourrapide.com rhyta.com superrito.com teleworm.us incognitomail.org incognitomail.com '+
    'incognitomail.net crazymailing.com emailnator.com byom.de muellmail.com einmalmail.de sofort-mail.de spoofmail.de '+
    'mailnull.com getonemail.com deadaddress.com meltmail.com mailtemporaire.fr mailtemporaire.com correotemporal.org').split(' '));
  const JEDNORAZOWE_W_NAZWIE=/10minute|minutemail|tempmail|temp-mail|throwaway|trashmail|trash-mail|guer+il+amail|mailinator|yopmail|disposable|fakeinbox|fakemail|wegwerf|discardmail|spambox|burnermail|jetable/;
  const poprawnyAdres=a=>{
    const m=/^([^@\s]{1,64})@([^@\s]{3,253})$/.exec(a);
    if(!m || a.length>254) return false;
    const nazwa=m[1], domena=m[2].toLowerCase();
    if(!/^[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+)*$/.test(nazwa)) return false;
    if(!/^(?:[\p{L}\p{N}](?:[\p{L}\p{N}-]{0,61}[\p{L}\p{N}])?\.)+(?:\p{L}{2,63}|xn--[a-z0-9-]{1,59})$/u.test(domena)) return false;
    const czesci=domena.split('.');
    for(let k=0;k<czesci.length-1;k++) if(JEDNORAZOWE.has(czesci.slice(k).join('.'))) return false;
    return !JEDNORAZOWE_W_NAZWIE.test(domena);
  };
  let poleBledu=null;
  const blad=(t,pole)=>{
    komN.textContent=t; komN.classList.add('zle'); poleBledu=pole||null;
    if(pole){ pole.setAttribute('aria-invalid','true'); pole.focus(); }
  };
  const poPoprawce=pole=>{
    pole.removeAttribute('aria-invalid');
    if(poleBledu===pole){ komN.textContent=''; komN.classList.remove('zle'); poleBledu=null; }
  };
  mailN.addEventListener('input',()=>poPoprawce(mailN));
  zgodaN.addEventListener('change',()=>poPoprawce(zgodaN));
  formN.addEventListener('submit',e=>{
    komN.classList.remove('zle'); komN.textContent='';
    const adres=mailN.value.trim();
    // najpierw adres, dopiero potem zgoda - naraz jeden komunikat
    if(!poprawnyAdres(adres)){ e.preventDefault(); return blad(ang?'Invalid email address.':'Nieprawidłowy adres e-mail.',mailN); }
    if(!zgodaN.checked){ e.preventDefault(); return blad(ang?'Please tick the required box.':'Zaznacz wymagane.',zgodaN); }
    if(navigator.onLine===false){ e.preventDefault(); return blad(ang?'You are offline. Check your connection and try again.':'Brak internetu. Sprawdź połączenie i spróbuj jeszcze raz.'); }
    mailN.value=adres;
    tagiN.value='newsletter,zrodlo-'+zrodloZapisu;
    komN.textContent=ang?'Sending…':'Wysyłam…';
    setTimeout(()=>{ guzN.disabled=true; },0);          // po wyslaniu: kolejne klikniecia nic nie robia
  });
  // po powrocie z Shopify: udany zapis albo blad
  if($('#zapis-ok')){
    pamiec('localStorage','dreamy-newsletter','zapisany');
    okno.classList.add('gotowe'); pokazOkno(true,naglowekWidoku(),true);
    setTimeout(()=>udaneN.focus({preventScroll:true}),260);
  }else if($('#zapis-blad')){
    pokazOkno(true,naglowekWidoku(),true);
    setTimeout(()=>blad(ang?'Could not sign you up. Check the address and try again.':'Nie udało się zapisać. Sprawdź adres i spróbuj jeszcze raz.',mailN),260);
  }else if(!jestZapisany() && pamiec('sessionStorage','dreamy-newsletter-pokazane')!=='1'){
    // okienko samo pokazuje sie raz na wizyte i nigdy po zapisie
    // baner zgody na cookies (Shopify) ma pierwszenstwo: dwa okienka naraz zaslaniaja strone i gubia fokus
    const banerCookies=()=>{ const b=document.getElementById('shopify-pc__banner');
      return !!b && b.getClientRects().length>0 && getComputedStyle(b).visibility!=='hidden'; };
    const pokazSamo=()=>{
      if(oknoOtwarte||koszykOtwarty||menuOtwarte||jestZapisany()||banerCookies()) return false;
      pamiec('sessionStorage','dreamy-newsletter-pokazane','1');
      zrodloZapisu='wejscie';
      pokazOkno(true,naglowekWidoku(),true);
      return true;
    };
    // telefon: dopiero gdy zdjecie produktu (albo hero) zniknie u gory ekranu, zeby nie zaslaniac maski na wejsciu
    const kotwica=matchMedia('(max-width:880px)').matches && ($('#foto')||$('.hero')||$('main h1'));
    if(kotwica){
      const sprawdz=()=>{ if(kotwica.getBoundingClientRect().bottom<0 && pokazSamo()) removeEventListener('scroll',sprawdz); };
      addEventListener('scroll',sprawdz,{passive:true});
    }else{ const probuj=()=>{ if(!pokazSamo() && banerCookies()) setTimeout(probuj,700); }; setTimeout(probuj,900); }
  }

  addEventListener('keydown',e=>{
    if(e.key!=='Escape') return;
    if(oknoOtwarte) pokazOkno(false);         // najpierw okienko newslettera
    else if(koszykOtwarty) otworz(false);     // potem koszyk
    else if(menuOtwarte) otworzMenu(false);   // na koncu menu
  });

  // ---- przelacznik jezyka ----
  const PL='<svg viewBox="0 0 30 20" aria-hidden="true"><rect width="30" height="10" fill="#F1E8EA"/><rect y="10" width="30" height="10" fill="#D4213D"/></svg>', GB='<svg viewBox="0 0 30 20" aria-hidden="true"><rect width="30" height="20" fill="#012169"/><path d="M0 0l30 20M30 0L0 20" stroke="#fff" stroke-width="4"/><path d="M0 0l30 20M30 0L0 20" stroke="#C8102E" stroke-width="2"/><path d="M15 0v20M0 10h30" stroke="#fff" stroke-width="6.5"/><path d="M15 0v20M0 10h30" stroke="#C8102E" stroke-width="3.9"/></svg>';
  const przyciskiJezyka=$$('.lang');
  const teksty=$$('[data-en]').map(e=>({e,pl:e.textContent}));
  const atrybuty=['aria-label','placeholder','alt'].flatMap(a=>$$(`[data-en-${a}]`).map(e=>({e,a,pl:e.getAttribute(a)})));
  przyciskiJezyka.forEach(p=>p.addEventListener('click',()=>{
    ang=!ang;
    teksty.forEach(({e,pl})=>{ e.textContent=ang?e.dataset.en:pl; });
    atrybuty.forEach(({e,a,pl})=>e.setAttribute(a, ang?e.getAttribute(`data-en-${a}`):pl));
    przyciskiJezyka.forEach(b=>{
      b.innerHTML=ang?GB:PL;
      b.setAttribute('aria-label',ang?'Switch language to Polish':'Zmień język na angielski');
    });
    doc.lang=ang?'en':'pl';
    komN.textContent=''; komN.classList.remove('zle');
    if(koszyk) rysuj(koszyk);
    ustawZestaw();
  }));
})();
